
import { Partner } from "@app/models/partner/IPartner";
import { PeakworkRequest } from "@app/models/peakwork/PeakworkRequest";
import moment from "moment";

export class ObjFilterPeakwork {
    protected realparams: any;
    protected partner: Partner;
    protected limit: number = 5;
    constructor(partner: Partner, limit, realparams) {
        this.partner = partner;
        this.realparams = realparams;
        this.limit = limit;
    }


    getFilter(from?: string): PeakworkRequest {
        const peakfilter: PeakworkRequest = {
            currency: this.partner.partnercurrency,
            language: 'de',
            authKey: this.partner.peakwork?.apikey,
            display: {
                pricesByPax: true,
                priceType: 'PER_PERSON',
                localTime: false,
                additionalFlightInfo: true,
                productCount: true,
                ratings: false,
                giataFacts: true
            },
            travelPeriod: {
                departureDate: '2025-04-10',
                returnDate: '2025-04-30',
                durations: [
                    7
                ]
            },
            persons: [
                {
                    age: 30,
                    refId: 1
                },
                {
                    age: 30,
                    refId: 2
                },
            ],
            paging: {
                sortingOrder: {
                    order: 'PRICE_ASC',
                    index: 1
                }
            },
            // tourOperators: ['COS_P']
        };

        if (from === 'region') {
            delete peakfilter.paging;

            switch (this.realparams.sortBy) {
                case 'regionName':
                case 'hotelName':
                    peakfilter.sortingOrder = '"NAME_ASC';
                    break;

                default:
                    peakfilter.sortingOrder = 'PRICE_ASC';
                    break;
            }
        }

        if (this.realparams.pauschalreiseResult) {
            if (this.realparams.pauschalreiseResult.type === 1) {
                if (String(this.realparams.pauschalreiseResult.data?.code).includes('_')) {
                    const tmp = String(this.realparams.pauschalreiseResult.data?.code).split('_');
                    peakfilter.hotel = {
                        accomodationCodes: [tmp[1]]
                    }
                } else {
                    peakfilter.hotel = {
                        references: {
                            giataIds: [Number(this.realparams.pauschalreiseResult.data?.code)]
                        }
                    }
                }

            } else if (this.realparams.pauschalreiseResult.type === 2) {
                peakfilter.location = {
                    cityCodes: [Number(this.realparams.pauschalreiseResult.data?.code)]
                }
            } else if (this.realparams.pauschalreiseResult.type === 3) {
                peakfilter.location = {
                    regionCodes: [Number(this.realparams.pauschalreiseResult.data?.code)]
                }
            } else if (this.realparams.pauschalreiseResult.type === 4) {
                peakfilter.location = {
                    countryCodes: [this.realparams.pauschalreiseResult.data?.code]
                }
            }
        }

        if (this.realparams.reisezeitraumResult.start && this.realparams.reisezeitraumResult.end) {
            if (!isNaN(Number(this.realparams?.reisezeitraumResult?.start))) {
                this.realparams.reisezeitraumResult.start = moment().add(Number(this.realparams.reisezeitraumResult.start), 'days').format('YYYY-MM-DD');
                this.realparams.reisezeitraumResult.end = moment().add(Number(this.realparams.reisezeitraumResult.end), 'days').format('YYYY-MM-DD');
            } else {
                this.realparams.reisezeitraumResult.start = moment(this.realparams.reisezeitraumResult.start).format('YYYY-MM-DD');
                this.realparams.reisezeitraumResult.end = moment(this.realparams.reisezeitraumResult.end).format('YYYY-MM-DD');
            }
            peakfilter.travelPeriod = {
                departureDate: moment(new Date(this.realparams.reisezeitraumResult.start)).format('YYYY-MM-DD'),
                returnDate: moment(new Date(this.realparams.reisezeitraumResult.end)).format('YYYY-MM-DD'),
            }
        } else if (Number(this.realparams.reiseMonth) >= 0) {
            let year = moment().year();
            let start = '';
            let end = '';
            if (moment().month() > Number(this.realparams.reiseMonth)) {
                year += 1;
                start = moment().set({ date: 1, month: Number(this.realparams.reiseMonth), year: year }).format('YYYY-MM-DD');
                end = moment(start).add(60, 'days').format('YYYY-MM-DD');
            } else if (moment().month() === Number(this.realparams.reiseMonth)) {
                start = moment().format('YYYY-MM-DD');
                end = moment(start).add(60, 'days').format('YYYY-MM-DD');
            } else {
                start = moment().set({ date: 1, month: Number(this.realparams.reiseMonth), year: year }).format('YYYY-MM-DD');
                end = moment(start).add(60, 'days').format('YYYY-MM-DD');
            }
            peakfilter.travelPeriod = {
                departureDate: start,
                returnDate: end,
            }
        }
        peakfilter.travelPeriod.durations = [];
        if (Number(this.realparams?.reisezeitraumResult?.minDuration) === -1) {
            peakfilter.travelPeriod.durations.push(moment.duration(moment(this.realparams?.reisezeitraumResult?.end).diff(this.realparams?.reisezeitraumResult?.start)).asDays());
        } else {
            for (let i = Number(this.realparams.reisedauerResult.minDuration); i <= Number(this.realparams.reisedauerResult.maxDuration); i++) {
                peakfilter.travelPeriod.durations.push(i);
            }
        }

        if (from === 'region') {
            peakfilter.limitDepth = this.limit;
        } else {
            peakfilter.paging.perPage = this.limit;
        }

        if (Number(this.realparams.minCategory) > 0) {
            if (peakfilter.hotel) {
                peakfilter.hotel.category = Number(this.realparams.minCategory);
            } else {
                peakfilter.hotel = {
                    category: Number(this.realparams.minCategory)
                }
            }
        }

        // maxPricePerPerson
        if (this.realparams.maxPricePerPerson) {
            peakfilter.maxPrice = Number(this.realparams.maxPricePerPerson);
        } else {
            peakfilter.maxPrice = null;
        }

        // minPricePerPerson
        if (this.realparams.minPricePerPerson) {
            peakfilter.minPrice = Number(this.realparams.minPricePerPerson);
        } else {
            peakfilter.minPrice = null;
        }

        if (Number(this.realparams?.giataIdList) > 0) {
            if (peakfilter.hotel) {
                if (peakfilter.hotel.references) {
                    if (peakfilter.hotel.references.giataIds) {
                        const tmp_ind = peakfilter.hotel.references.giataIds.indexOf(Number(this.realparams?.giataIdList));
                        if (tmp_ind < 0) {
                            peakfilter.hotel.references.giataIds.push(Number(this.realparams?.giataIdList));
                        }
                    } else {
                        peakfilter.hotel.references.giataIds = [Number(this.realparams?.giataIdList)];
                    }
                } else {
                    peakfilter.hotel.references = {
                        giataIds: [Number(this.realparams?.giataIdList)]
                    }
                }
            } else {
                peakfilter.hotel = {
                    references: {
                        giataIds: [Number(this.realparams?.giataIdList)]
                    }
                }
            }
        }

        if (this.realparams.flight?.stopover?.length > 0) {
            if (peakfilter.transport) {
                peakfilter.transport.stopOver = Number(this.realparams.flight.stopover);
            } else {
                peakfilter.transport = {
                    stopOver: Number(this.realparams.flight.stopover)
                }
            }
        } else if (this.realparams.flight?.directness === 'N') {
            if (peakfilter.transport) {
                peakfilter.transport.stopOver = 0;
            } else {
                peakfilter.transport = {
                    stopOver: 0
                };
            }
        }


        const aircodes: string[] = [];
        for (let i = 0; i < this.realparams.airportsResult?.length; i++) {
            aircodes.push(this.realparams.airportsResult[i].code);
        }
        if (aircodes.length > 0) {
            if (peakfilter.transport) {
                peakfilter.transport.departureAirports = {
                    values: aircodes
                };
            } else {
                peakfilter.transport = {
                    departureAirports: {
                        values: aircodes
                    }
                };
            }
        } else {
            peakfilter?.transport?.departureAirports && delete peakfilter.transport.departureAirports;
        }

        const airlines: string[] = [];
        for (let i = 0; i < this.realparams.flightCarrierList?.length; i++) {
            airlines.push(this.realparams.flightCarrierList[i].code);
        }
        if (airlines.length > 0) {
            if (peakfilter.transport) {
                peakfilter.transport.airlines = {
                    values: airlines
                };
            } else {
                peakfilter.transport = {
                    airlines: {
                        values: airlines
                    }
                };
            }
        } else {
            peakfilter?.transport?.airlines && delete peakfilter.transport.airlines;
        }

        if (peakfilter?.transport) {
            peakfilter.transport.transportType = 'FLIGHT';
        }

        // peakfilter.tourOperators = [];
        // for (let i = 0; i < this.realparams.tourOperatorList?.length; i++) {
        //     peakfilter.tourOperators.push(this.realparams.flightCarrierList[i].code);
        // }
        // if (peakfilter.tourOperators.length === 0) {
        //     peakfilter.tourOperators && delete peakfilter.tourOperators;
        // }

        if (this.realparams.hotelChainList?.length > 0) {
            if (peakfilter.hotel) {
                peakfilter.hotel.chain = this.realparams.hotelChainList[0].code;
            } else {
                peakfilter.hotel = {
                    chain: this.realparams.hotelChainList[0].code
                }
            }
        }


        if (this.realparams.reisendeResult) {
            peakfilter.persons = [];
            // console.log(this.realparams.reisendeResult)
            let travcount = 0;
            for (let i = 0; i < this.realparams.reisendeResult.adults; i++) {
                travcount++;
                peakfilter.persons.push({
                    age: 30,
                    refId: travcount
                });
            }
            for (let i = 0; i < this.realparams.reisendeResult.children?.length; i++) {
                travcount++;
                peakfilter.persons.push({
                    age: this.realparams.reisendeResult.children[i].age,
                    refId: travcount
                });
            }
        }


        // rooms
        if (this.realparams.boardTypeList?.length > 0) {
            const tmp_Board = [];
            for (let i = 0; i < this.realparams.boardTypeList.length; i++) {
                if (this.realparams.boardTypeList[i].code === 'OV') {
                    tmp_Board.push('GT06-AO');
                    tmp_Board.push('GT06-XX');
                }
                if (this.realparams.boardTypeList[i].code === 'UF') {
                    tmp_Board.push('GT06-BB');
                }
                if (this.realparams.boardTypeList[i].code === 'HP') {
                    tmp_Board.push('GT06-HB');
                }
                if (this.realparams.boardTypeList[i].code === 'VP') {
                    tmp_Board.push('GT06-HBP');
                }
                if (this.realparams.boardTypeList[i].code === 'AI') {
                    tmp_Board.push('GT06-AI');
                }
            }

            if (peakfilter.hotel) {
                if (peakfilter.hotel.rooms?.length > 0) {
                    peakfilter.hotel.rooms[0].boardTypes = tmp_Board;
                } else {
                    peakfilter.hotel.rooms = [
                        { boardTypes: tmp_Board }
                    ];
                }
            } else {
                peakfilter.hotel = {
                    rooms: [
                        { boardTypes: tmp_Board }
                    ]
                };
            }
        }

        // zimmer
        if (this.realparams.roomTypeList?.length > 0) {
            const tmp_rooms = [];
            // console.log(this.realparams.roomTypeList)
            for (let i = 0; i < this.realparams.roomTypeList.length; i++) {
                if (this.realparams.roomTypeList[i].code === 'DZ') {
                    tmp_rooms.push('ST04-DO');
                }
                if (this.realparams.roomTypeList[i].code === 'AP') {
                    tmp_rooms.push('ST04-AP');
                }
                if (this.realparams.roomTypeList[i].code === 'DX') {
                    tmp_rooms.push('AT04-DPSU');
                }
                if (this.realparams.roomTypeList[i].code === 'EZ') {
                    tmp_rooms.push('ST04-SI');
                }
                if (this.realparams.roomTypeList[i].code === 'VI') {
                    tmp_rooms.push('ST04-VI');
                }
                if (this.realparams.roomTypeList[i].code === 'FZ') {
                    tmp_rooms.push('ST04-FA');
                }
                if (this.realparams.roomTypeList[i].code === 'SU') {
                    tmp_rooms.push('T04-SU');
                    tmp_rooms.push('ST04-JS');
                }
            }

            if (peakfilter.hotel) {
                if (peakfilter.hotel.rooms?.length > 0) {
                    peakfilter.hotel.rooms[0].types = {
                        values: tmp_rooms
                    }
                } else {
                    peakfilter.hotel.rooms = [
                        { types: { values: tmp_rooms } }
                    ];
                }
            } else {
                peakfilter.hotel = {
                    rooms: [
                        { types: { values: tmp_rooms } }
                    ]
                };
            }
        }

        // meerblick
        const tmp_views = [];
        if (this.realparams.zommermitmeerblick) {
            tmp_views.push('GT13-SEVI');
        }

        if (this.realparams.meerseite) {
            tmp_views.push('AT13-SIDE');
        }

        if (tmp_views?.length > 0) {
            if (peakfilter.hotel) {
                if (peakfilter.hotel.rooms?.length > 0) {
                    peakfilter.hotel.rooms[0].views = {
                        values: tmp_views
                    }
                } else {
                    peakfilter.hotel.rooms = [
                        { views: { values: tmp_views } }
                    ];
                }
            } else {
                peakfilter.hotel = {
                    rooms: [
                        { views: { values: tmp_views } }
                    ]
                };
            }
        }

        peakfilter.transfer = false;
        if (this.realparams?.transferlist?.length > 0 && this.realparams?.transferlist?.indexOf('MT') >= 0) {
            peakfilter.transfer = true;
        }

        const tmp_keys = [];
        for (let i = 0; i < this.realparams?.keywordList?.length; i++) {
            switch (this.realparams.keywordList[i].code) {
                case 'bea':
                    tmp_keys.push('ST03-DIRE');
                    break;
                case 'fcp':
                    tmp_keys.push('GT03-CHPO');
                    break;
                case 'wdt':
                    tmp_keys.push('ST03-DICU');
                    tmp_keys.push('ST03-SCCU');
                    break;
                case 'ipl':
                    tmp_keys.push('ST03-INSW');
                    break;
                case 'pol':
                    tmp_keys.push('GT03-POOL');
                    // tmp_keys.push('GT05-PRPO');
                    // tmp_keys.push('GT05-SWPO');
                    // tmp_keys.push('GT05-WHJA');
                    // tmp_keys.push('ST03-25PO');
                    // tmp_keys.push('ST03-50PO');
                    // tmp_keys.push('ST03-AQPA');
                    // tmp_keys.push('ST03-BEAC');
                    // tmp_keys.push('ST03-FLLI');
                    // tmp_keys.push('ST03-FRPO');
                    // tmp_keys.push('ST03-POOL');
                    // tmp_keys.push('ST03-PRIV');
                    break;
                case 'wsl':
                    tmp_keys.push('GT03-WASL');
                    break;
                case 'fbs':
                    tmp_keys.push('GT03-BASE');
                    tmp_keys.push('GT03-FAMI');
                    break;
                case 'ecc':
                    tmp_keys.push('GT03-CHIL');
                    tmp_keys.push('ST02-CL');
                    break;
                case 'rcb':
                    tmp_keys.push('GT05-CHBE');
                    break;
                case 'chf':
                    tmp_keys.push('GT03-FAMI');
                    break;
                case 'emc':
                    tmp_keys.push('GT03-FAMI');
                    tmp_keys.push('GT03-KICL');
                    break;
                case 'fpg':
                    tmp_keys.push('GT03-CHPL');
                    break;
                case 'eec':
                    tmp_keys.push('ST19-CHEN');
                    break;
                case 'fpr':
                    tmp_keys.push('GT03-CHPA');
                    break;
                case 'wms':
                    tmp_keys.push('GT05-WHJA');
                    tmp_keys.push('ST03-ABMA');
                    tmp_keys.push('ST03-CETR');
                    tmp_keys.push('ST03-CUGL');
                    tmp_keys.push('ST03-FBMA');
                    tmp_keys.push('ST03-FORE');
                    tmp_keys.push('ST03-HESP');
                    tmp_keys.push('ST03-HYMA');
                    tmp_keys.push('ST03-JESH');
                    tmp_keys.push('ST03-LATH');
                    tmp_keys.push('ST03-LOMA');
                    tmp_keys.push('ST03-LYDR');
                    tmp_keys.push('ST03-PBMA');
                    tmp_keys.push('ST03-SHIA');
                    tmp_keys.push('ST03-THMA');
                    tmp_keys.push('ST03-TUBA');
                    tmp_keys.push('ST03-TUMA');
                    tmp_keys.push('ST03-VINO');
                    tmp_keys.push('ST03-VISH');
                    tmp_keys.push('ST03-WHJA');
                    break;
                case 'wap':
                    tmp_keys.push('ST08-TRCH');
                    tmp_keys.push('GT03-TRCH');
                    tmp_keys.push('ST03-ACUP');
                    tmp_keys.push('ST03-ACUR');
                    tmp_keys.push('ST03-TUMA');
                    break;
                case 'way':
                    tmp_keys.push('ST08-AYUR');
                    tmp_keys.push('GT03-AYUR');
                    break;
                case 'wbf':
                    tmp_keys.push('ST03-BECE');
                    break;
                case 'wsn':
                    tmp_keys.push('GT05-SAUN');
                    tmp_keys.push('ST03-BANY');
                    tmp_keys.push('ST03-BISA');
                    tmp_keys.push('ST03-COLI');
                    tmp_keys.push('ST03-EUSA');
                    tmp_keys.push('ST03-FISA');
                    tmp_keys.push('ST03-HEBA');
                    tmp_keys.push('ST03-HESP');
                    tmp_keys.push('ST03-INSA');
                    tmp_keys.push('ST03-SAGR');
                    tmp_keys.push('ST03-SOST');
                    tmp_keys.push('ST03-WAAI');
                    break;
                case 'wth':
                    tmp_keys.push('ST03-THAG');
                    tmp_keys.push('ST03-THAL');
                    break;
                case 'wel':
                    tmp_keys.push('GT05-SAUN');
                    tmp_keys.push('GT05-PRPO');
                    tmp_keys.push('GT05-POOL');
                    tmp_keys.push('GT05-WHJA');
                    tmp_keys.push('ST03-ABMA');
                    tmp_keys.push('ST03-ACUP');
                    tmp_keys.push('ST03-ACUR');
                    tmp_keys.push('ST03-ANAG');
                    tmp_keys.push('ST03-AROM');
                    tmp_keys.push('ST03-AUTR');
                    tmp_keys.push('ST03-BAEX');
                    tmp_keys.push('ST03-BALN');
                    tmp_keys.push('ST03-BANY');
                    tmp_keys.push('ST03-BECE');
                    tmp_keys.push('ST03-BISA');
                    tmp_keys.push('ST03-BRTH');
                    tmp_keys.push('ST03-CETR');
                    tmp_keys.push('ST03-CHMA');
                    tmp_keys.push('ST03-CHYA');
                    tmp_keys.push('ST03-CLBA');
                    tmp_keys.push('ST03-COLI');
                    tmp_keys.push('ST03-CUGL');
                    tmp_keys.push('ST03-DRCU');
                    tmp_keys.push('ST03-ELEC');
                    tmp_keys.push('ST03-EUSA');
                    tmp_keys.push('ST03-EVPR');
                    tmp_keys.push('ST03-EXFO');
                    tmp_keys.push('ST03-EXSH');
                    tmp_keys.push('ST03-FACI');
                    tmp_keys.push('ST03-FACU');
                    tmp_keys.push('ST03-FANG');
                    tmp_keys.push('ST03-FISA');
                    tmp_keys.push('ST03-FLLI');
                    tmp_keys.push('ST03-FORE');
                    tmp_keys.push('ST03-HABA');
                    tmp_keys.push('ST03-HEBA');
                    tmp_keys.push('ST03-HESP');
                    tmp_keys.push('ST03-HOSP');
                    tmp_keys.push('ST03-HYMA');
                    tmp_keys.push('ST03-IRBA');
                    tmp_keys.push('ST03-JESH');
                    tmp_keys.push('ST03-KNCU');
                    tmp_keys.push('ST03-LATH');
                    tmp_keys.push('ST03-LOMA');
                    tmp_keys.push('ST03-LYDR');
                    tmp_keys.push('ST03-MANI');
                    tmp_keys.push('ST03-MEBA');
                    tmp_keys.push('ST03-OXTH');
                    break;
                case 'ani':
                    tmp_keys.push('ST02-CL');
                    tmp_keys.push('ST03-CHEN');
                    tmp_keys.push('ST03-DAEN');
                    tmp_keys.push('ST03-ENAD');
                    tmp_keys.push('ST03-ENYO');
                    tmp_keys.push('ST03-EVEN');
                    tmp_keys.push('ST03-SPEN');
                    break;
                case 'sae':
                    tmp_keys.push('ST08-AERO');
                    tmp_keys.push('GT03-AERO');
                    tmp_keys.push('ST03-TABO');
                    break;
                case 'sbs':
                    tmp_keys.push('GT08-GOLF');
                    tmp_keys.push('GT03-BASK');
                    tmp_keys.push('GT03-GOLF');
                    tmp_keys.push('ST03-BEBS');
                    tmp_keys.push('ST03-GOLF');
                    break;
                case 'shb':
                    tmp_keys.push('ST08-HIKI');
                    tmp_keys.push('GT03-HIAR');
                    tmp_keys.push('GT03-HIKI');
                    tmp_keys.push('GT03-NATU');
                    tmp_keys.push('ST02-CE');
                    tmp_keys.push('ST03-MOH');
                    tmp_keys.push('ST08-MOBI');
                    tmp_keys.push('ST03-BMDO');
                    tmp_keys.push('ST03-MOBI');
                    break;
                case 'sdv':
                    tmp_keys.push('GT08-DIVI');
                    tmp_keys.push('ST08-DISA');
                    tmp_keys.push('GT03-DIVI');
                    break;
                case 'sfr':
                    tmp_keys.push('ST03-FIRO');
                    tmp_keys.push('ST03-STTR');
                    break;
                case 'sgl':
                    tmp_keys.push('ST03-09HO');
                    tmp_keys.push('ST03-18HO');
                    tmp_keys.push('ST03-27HO');
                    tmp_keys.push('ST03-GOCO');
                    tmp_keys.push('ST03-GOLF');
                    tmp_keys.push('ST03-HARE');
                    tmp_keys.push('ST03-LE18');
                    tmp_keys.push('ST03-MI18');
                    tmp_keys.push('ST03-SHCO');
                    tmp_keys.push('GT12-GEMA');
                    tmp_keys.push('GT12-GRIS');
                    tmp_keys.push('GT13-GOSI');
                    tmp_keys.push('GT13-GOVI');
                    break;
                case 'srd':
                    tmp_keys.push('ST08-HORI');
                    tmp_keys.push('GT03-HORI');
                    break;
                case 'stn':
                    tmp_keys.push('ST03-TENN');
                    break;
                case 'sws':
                    tmp_keys.push('ST19-BOAT');
                    tmp_keys.push('ST08-KITE');
                    tmp_keys.push('ST08-ROWI');
                    tmp_keys.push('ST08-SAIL');
                    tmp_keys.push('ST08-SURF');
                    tmp_keys.push('ST08-WIND');
                    tmp_keys.push('GT03-BABO');
                    tmp_keys.push('GT03-CANO');
                    tmp_keys.push('GT03-CATA');
                    tmp_keys.push('GT03-DIVI');
                    tmp_keys.push('GT03-DIWS');
                    tmp_keys.push('GT03-FISH');
                    tmp_keys.push('GT03-KAYA');
                    tmp_keys.push('GT03-KITE');
                    tmp_keys.push('GT03-PEBO');
                    tmp_keys.push('GT03-RAFT');
                    tmp_keys.push('GT03-ROWI');
                    tmp_keys.push('GT03-SAIL');
                    tmp_keys.push('GT03-SNOR');
                    tmp_keys.push('GT03-SURF');
                    tmp_keys.push('GT03-WAPO');
                    tmp_keys.push('GT03-WASP');
                    tmp_keys.push('GT03-WATE');
                    tmp_keys.push('GT03-WIND');
                    tmp_keys.push('ST03-PADI');
                    tmp_keys.push('ST03-SCHO');
                    tmp_keys.push('ST03-WACE');
                    break;
                case 'fwi':
                    tmp_keys.push('ST03-WLAN');
                    tmp_keys.push('AT22-WLAN');
                    break;
                case 'ado':
                    tmp_keys.push('ST21-ADON');
                    tmp_keys.push('GT03-ADON');
                    break;

                default:
                    break;
            }
        }

        // console.log(this.realparams.keywordList);
        // if (this.realparams.keywordList?.length > 0) {
        //     for (let i = 0; i < this.realparams.keywordList.length; i++) {
        //         // this.filtersData.keywordList += '' + this.realparams.keywordList[i].code;
        //         // if (i < this.realparams.keywordList.length - 1) {
        //         //     this.filtersData.keywordList += ',';
        //         // }
        //     }
        // }

        // if (this.realparams.getrennteschlafzimmer) {
        //     // this.filtersData.keywordList += this.filtersData.keywordList.length > 0 ? ',rbe' : 'rbe';
        // }

        if (tmp_keys?.length > 0) {
            if (peakfilter.hotel) {
                peakfilter.hotel.globalTypeList = {
                    values: tmp_keys,
                    // attributeOperator: 'AND',
                    // fqn: true
                }
            } else {
                peakfilter.hotel = {
                    globalTypeList: {
                        values: tmp_keys,
                        // attributeOperator: 'AND',
                        // fqn: true
                    }
                };
            }
        }

        // console.log(peakfilter)
        return peakfilter;
    }
}